import { TextLinkWidget } from '@tableau/widgets';
import React from 'react';

import { HelpService } from '~commonInfra/services/HelpService';
import { Messages } from '~src/codegen/Localize';
import { FormikCheckbox } from '~src/commonInfra/components/FormikCheckbox';
import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';
import { UpdateBooleanServerSettingNames } from '~src/settings/ServerApi/requests/serverSettings/UpdateBooleanServerSettingRequest';
import { ServerSettingsInstance } from '~src/settings/services/ServerSettings';

import { SettingsSection } from '../../../../components/common/SettingsSection';
import { learnMoreStyle } from '../../../../styles/CommonStyles';
import { ServerSettingsProps } from '../../server-settings/ReactServerSettings';
import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';


export const GROUP_ASSERTIONS_SERVER_ENABLED_FIELD = 'settings.groupAssertionsEnabled';
export const GROUP_ASSERTIONS_SERVER_SECTION_TEST_ID = 'group-assertions-server-setting-section';
export const GROUP_ASSERTIONS_SERVER_ENABLED_CHECKBOX_TEST_ID = 'group-assertions-server-enabled';
export const GROUP_ASSERTIONS_SERVER_LEARN_MORE_LINK_TEST_ID = 'group-assertions-learn-more-link';

export type ServerGroupAssertionsSectionProps = ServerSettingsProps<'groupAssertionsEnabled'>;

export function ServerGroupAssertionsSection(props: ServerGroupAssertionsSectionProps): React.ReactElement {
    if(!FeatureFlags.abacassertedLocalGroupsEnabled) {
        return null;
    }
    return (
        <SettingsSection
                description={renderDescription()}
                title={Messages.groupAssertionsSettingTitle()}
                testId={GROUP_ASSERTIONS_SERVER_SECTION_TEST_ID}>
                <FormikCheckbox
                    label={Messages.groupAssertionsServerSettingLabel()}
                    name={GROUP_ASSERTIONS_SERVER_ENABLED_FIELD}
                    testId={GROUP_ASSERTIONS_SERVER_ENABLED_CHECKBOX_TEST_ID} />
            </SettingsSection>
    );
}

function renderDescription() {
  return (
    <div>
      {Messages.groupAssertionsServerSettingDescription()}
      <TextLinkWidget testId={GROUP_ASSERTIONS_SERVER_LEARN_MORE_LINK_TEST_ID}
                      target={'_blank'}
                      className={learnMoreStyle}
                      href={HelpService.getHelpUrlByCategory('group-assertions')}>
        {Messages.learnMore()}
      </TextLinkWidget>
    </div>
  );
}

/* for registering the component in settings registry */
export const ServerGroupAssertionsSectionSpecs = componentRegistryEntry({
    name: 'ServerGroupAssertionsSection',
    component: ServerGroupAssertionsSection,
    onSubmit: (settings) => {
      if(settings.groupAssertionsEnabled !== undefined) {
        ServerSettingsInstance.updateBoolean(UpdateBooleanServerSettingNames.groupAssertionsEnabled, settings.groupAssertionsEnabled);
      }
    }
});
